import {useQueryGetDetailSanctions, useQuerySearchSanctions} from "src/services/queries/useQuerySanctions";
import {
  Box,
  Chip,
  Container, Paper,
  Stack,
  styled, Table, TableBody,
  TableCell,
  tableCellClasses, TableContainer,
  TableRow,
  TextField,
  Typography,
  TableHead
} from "@mui/material";
import React from "react";
import {useNavigate, useParams} from "react-router-dom";
import {SANCTION_TOPICS} from "src/utils/constants/sanctions";
import {checkSanctionObject} from "src/utils/helpers/sanctions";
import {convertCamelCaseToNormalText} from "src/utils/helpers/stringHelpers";
import BreadcrumbWithBtnBack from "src/components/BreadcrumbWithBtnBack";
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

function createData(
  name: string,
  calories: number,
  fat: number,
  carbs: number,
  protein: number,
) {
  return { name, calories, fat, carbs, protein };
}

const rows = [
  createData('Frozen yoghurt', 159, 6.0, 24, 4.0),
  createData('Ice cream sandwich', 237, 9.0, 37, 4.3),
  createData('Eclair', 262, 16.0, 24, 6.0),
  createData('Cupcake', 305, 3.7, 67, 4.3),
  createData('Gingerbread', 356, 16.0, 49, 3.9),
];


const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const DataPropertyTable = (props: {data: any, name?: string, subName?: string}) => {
  const { data, name, subName } = props;
  const sanctionEntityFields:string[] = [];
  return (<Stack gap={2}>
    {name && <Typography variant={'h5'} mb={1}>{name}</Typography>}
    {subName && <Box fontWeight={'bold'} mb={1}>{subName}</Box>}
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 700 }} aria-label="customized table">
        <TableBody>
          {Object.keys(data.properties).map((property) => {
            const dataProperty = data.properties[property];
            const sanctionObjectInfo = checkSanctionObject(property, dataProperty);
            if(sanctionObjectInfo) {
              sanctionEntityFields.push(property);
              return null
            };
            return (<StyledTableRow key={dataProperty}>
              <StyledTableCell component="th" scope="row">
                {convertCamelCaseToNormalText(property)}
              </StyledTableCell>
              <StyledTableCell align="right">{dataProperty.join(',')}</StyledTableCell>
            </StyledTableRow>)
          })}
        </TableBody>
      </Table>
    </TableContainer>
    <Stack flexDirection={'column'} gap={2}>
      {sanctionEntityFields.map((sanctionField, parentIndex) => {
        const sanctionEntitiesArray = data.properties[sanctionField];
        return sanctionEntitiesArray.map((entity: any, childIndex: number) => {
          return <DataPropertyTable data={entity} key={entity.id} subName={`Field Name: ${convertCamelCaseToNormalText(sanctionField)} - Schema: ${entity.schema} - ${entity.caption}`.replace(`- ${entity.schema}`, '')} />
        })
      })}
    </Stack>

  </Stack>)
}



const StyledContainer = styled(Container)(({ theme }) => ({
  paddingTop: theme.spacing(3),
  paddingBottom: theme.spacing(7),
  marginTop: 8,
}));

const SanctionDetail = () => {
  const params = useParams();
  const navigate = useNavigate();

  const resp = useQueryGetDetailSanctions(params.id || '')
  const data = resp?.data?.data;

  if(resp.isFetching) return <StyledContainer>Loading...</StyledContainer>;

  if(!data) return <StyledContainer>Not found...</StyledContainer>
  return <StyledContainer>
    <BreadcrumbWithBtnBack
      listItem={
        [
          {
            text: 'Sanctions',
          },
          {
            text: `Sanctions Detail ${data.caption}`,
          },
        ]
      }
    />
    <Stack flexDirection={'column'} gap={2}>
      <Typography variant="h4" fontWeight={600}>{data.caption}</Typography>
      <Stack flexDirection={'row'} gap={1} width={'fit-content'}>
        {data.properties?.topics?.map((topic: string) => {
          return <Chip
            key={topic}
            color="secondary"
            label={SANCTION_TOPICS[topic] || topic}
            size="small"
            clickable={false}
            // sx={{
            //   '&:hover': {
            //     color: theme.palette.secondary.main,
            //     backgroundColor: alpha(theme.palette.secondary.main, 0.1),
            //   },
            // }}
          />
        })}
      </Stack>
      <Stack flexDirection={'column'} gap={3}>
        <DataPropertyTable name={'Facts Sheet'} data={data}/>
        {/*{Object.keys(data.properties).map( (property) => {*/}
        {/*  const dataProperty = data.properties[property];*/}
        {/*  const sanctionObjectInfo = checkSanctionObject(property, dataProperty);*/}
        {/*  if(!sanctionObjectInfo) return null;*/}

        {/*  return <Stack key={property}>*/}

        {/*    <Typography variant={'h5'} mb={2}>{sanctionObjectInfo.label}</Typography>*/}
        {/*    <Stack gap={2}>*/}
        {/*      {dataProperty.map((item:any, itemIndex: number) => {*/}
        {/*        return <DataPropertyTable subName={`${itemIndex + 1}. ` +(item.caption || '')} key={item.id} data={item}/>*/}
        {/*      })}*/}
        {/*    </Stack>*/}

        {/*  </Stack>*/}

        {/*})}*/}
      </Stack>

    </Stack>
  </StyledContainer>
}

export default SanctionDetail;
